import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { sentEmail, sentMobileMsg, customerContactSelect } from '@/api/gucangSales/customerCenter'
import { mobileValidate, emailValidate } from '@/utils/validate'
import type { PotentialItem } from '@/typings/api/customerCenter'

const __default__ = { name: 'sendLinkModel' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const optionsMobile = ref<any>([])
const optionsEmail = ref<any>([])
const editForm = ref<any>({})
const linkmethods = [
  { label: '短信', value: 'mobile' },
  { label: '邮件', value: 'email' }
]
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    try {
      const { otherTel, otherEmail } = editForm.value
      if (editForm.value.type === 'mobile') {
        await sentMobileMsg({
          cosId: editForm.value.cosId,
          mobile: otherTel ? editForm.value.mobile_other : editForm.value.mobile
        })
      } else if (editForm.value.type === 'email') {
        const email = editForm.value.email && editForm.value.email
        await sentEmail({
          cosId: editForm.value.cosId,
          email: otherEmail ? editForm.value.email_other : email
        })
      }
      loading.value = false
      message.success('发送成功')
      visible.value = false
    } catch (error) {
      loading.value = false
    }
  })
}
const toggle = (rows: PotentialItem) => {
  editForm.value = {
    type: 'mobile',
    cosId: rows.cosId,
    customerName: rows.customerName
  }
  visible.value = true
  if (rows.cosId) {
    fetch(rows.cosId)
  }
}
// 获取联系人列表
const fetch = (cosId: string) => {
  customerContactSelect({ cosId }).then((res) => {
    optionsMobile.value = res.data.filter((item: any) => item.mobile)
    if (optionsMobile.value && optionsMobile.value.length) {
      editForm.value.mobile = optionsMobile.value[0].mobile
    }
    optionsEmail.value = res.data.filter((item: any) => item.email)
    if (optionsEmail.value && optionsEmail.value.length) {
      editForm.value.email = optionsEmail.value[0].email
    }
  })
}
// 清楚校验
const clearVaild = (type: 'mobile' | 'email') => {
  if (type === 'mobile') {
    formRef.value?.clearValidate(['mobile', 'mobile_other'])
  } else if (type === 'email') {
    formRef.value?.clearValidate(['email', 'email_other'])
  }
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CosModal = _resolveComponent("CosModal")!

  return (_openBlock(), _createBlock(_component_CosModal, {
    visible: visible.value,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((visible).value = $event)),
    title: "发送注册链接",
    width: "670px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_alert, {
        message: "选择发送方式（短信/邮箱），系统会自动将注册链接以短信/邮件形式发给客户",
        type: "warning",
        "show-icon": ""
      }),
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            style: {"margin-top":"10px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "customerName",
                label: "客户名称",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: editForm.value.customerName,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.customerName) = $event)),
                    disabled: true
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "type",
                label: "发送方式",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    value: editForm.value.type,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.type) = $event)),
                    options: linkmethods
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              (editForm.value.type === 'mobile')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_a_form_item, {
                      name: "mobile",
                      label: "手机号",
                      rules: !editForm.value.otherTel ? [{ required: true, message: '请选择' }] : []
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: editForm.value.mobile,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.mobile) = $event)),
                          placeholder: "请选择",
                          disabled: editForm.value.otherTel ? true : false
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsMobile.value, (item) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: item.mobile,
                                value: item.mobile
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(`${item.mobile}(${item.name})`), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["rules"]),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: editForm.value.otherTel,
                          "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((editForm.value.otherTel) = $event)),
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (clearVaild('mobile')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("使用其他手机号")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _: 1
                    }),
                    (editForm.value.otherTel)
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 0,
                          name: "mobile_other",
                          label: "手机号",
                          rules: [
            { required: true, message: '请输入' },
            {
              validator: _unref(mobileValidate)
            }
          ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: editForm.value.mobile_other,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((editForm.value.mobile_other) = $event)),
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["rules"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_a_form_item, {
                      name: "email",
                      label: "邮箱",
                      rules: !editForm.value.otherEmail ? [{ required: true, message: '请选择' }] : []
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: editForm.value.email,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((editForm.value.email) = $event)),
                          placeholder: "请选择",
                          disabled: editForm.value.otherEmail ? true : false
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsEmail.value, (item, index) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: index,
                                value: item.email
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(`${item.email}(${item.name})`), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["rules"]),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: editForm.value.otherEmail,
                          "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((editForm.value.otherEmail) = $event)),
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (clearVaild('email')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("使用其他邮箱")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _: 1
                    }),
                    (editForm.value.otherEmail)
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 0,
                          label: "邮箱",
                          name: "email_other",
                          rules: [
            { required: true, message: '请输入' },
            {
              validator: _unref(emailValidate)
            }
          ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: editForm.value.email_other,
                              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((editForm.value.email_other) = $event)),
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["rules"]))
                      : _createCommentVNode("", true)
                  ], 64))
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "confirmLoading"]))
}
}

})